import { Column } from 'primereact/column'
import { useState, useEffect, useRef, useImperativeHandle, forwardRef } from 'react';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import BaseService from '../../../services/BaseService';
import CommonService from "../../../services/CommonService";
import DataGrid from '../../GenericComponents/DataGrid';

const NewIssuerMainContact = forwardRef((props, ref) => {
  const {onDataFetch, reportId, reportType} = props;
  const [isLoading, setIsLoading] = useState(true);
  const [newIssuerContact, setNewIssuerContact] = useState([]); //New issuer Contact in Review table


  useEffect(() => {
    if (reportId){
      getNewIssueContactById(reportId);
    }
   
  }, [reportId]);


  //I need to make this function generic so that I can use for RFS too 
  // since both reports will use this component
  const getNewIssueContactById = (selectedId) => {
    const opr = reportType === "RFS" ? "getNewIssueContactByFinalSaleId" : "getNewIssueContactByProposeDebtId";
    var obj = {
      msgId: null,
      sysId: null,
      opr: opr,
      hdrStruct: null,
      queryParam: null,
      reqData: {
        "issueId": selectedId
      },
    };

    BaseService.processRequest(obj)
      .then((res) => res)
      .then((result) => {
        Object.keys(result.data.responses).forEach((key) => {
          setNewIssuerContact(result.data.responses[key]);
          onDataFetch(result.data.responses[key]);
        });
        setIsLoading(false);

      });
  }


  useImperativeHandle(ref, () => {
      return {
        getNewIssueContactById
      };
  }, [])


  const  columnsNewIssuerContact = [{
    dataField: 'contactLastName',
    text: 'Contact Last Name',
    sort: true,
  }, {
    dataField: 'contactFirstName',
    text: 'Contact First Name',
    sort: true,
  }, {
    dataField: 'roleCodeDescription',
    text: 'Contact Role Description',
    sort: true,
  }
  ];


  return (
    <div>
      <div>
        <DataGrid
          title="New Issuer Main Contact:"
          dataSource={newIssuerContact}
          sortField='contactId'
          showQuickSearch={false}
          emptyDataMessage='No data available to display'
        >
          {columnsNewIssuerContact.map((column, i) => {
            return (
              <Column
                key={i}
                field={column.dataField}
                header={column.text}
                sortable={column.sort}
                body={column.formatter}
                hidden={column.hidden}
              />)
          })
          }
        </DataGrid>
      </div>
    </div>

  )
});

export default NewIssuerMainContact;

